export default __webpack_public_path__ + "static/textured-fb8bd01f6a5968e8551df8a98fb48015.webp";